import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { ProblematicEntityType, ProblematicEntityTypeSchema } from './problematic-entity.type';

export const QueryProblematicEntitiesSchema = z
    .object({
        entityType: ProblematicEntityTypeSchema,
        limit: z.coerce.number().int().min(1).max(500).optional(),
    })
    .strict();

/** Parsed shape from query; use for typing after ValidationPipe. */
export type QueryProblematicEntitiesDtoShape = z.infer<typeof QueryProblematicEntitiesSchema>;

export class QueryProblematicEntitiesDto extends FromSchema(QueryProblematicEntitiesSchema) {}
